import { useEffect, useRef, useState } from 'react';
import ImagenBannerNICRO from '../../assets/images/NICRO.avif';
import './NICRO.css';
import Facebok from '../../assets/images/Facebok.png';
import Wasa from '../../assets/images/Wasa.png';
import insta from '../../assets/images/insta.png';
import Telefono from '../../assets/images/Telefono.png';
import Ubi from '../../assets/images/Ubi.png';
import Email34 from '../../assets/images/Correo.png';
import RedesFondo from '../../assets/images/Red-Neuronal.png';
import checkAnim from '../../assets/images/check.gif';

function NICRO() {

    
  return (
    <>
    <div className="infra-banner-NICRO">
  <img src={ImagenBannerNICRO} alt="NICRO" className="banner-img-NICRO" />
    <h1 className="banner-texto-NICRO">NICRO</h1>
</div>
<div className="fondo-blanco-NICRO">
<div className="contenedor-NICRO">
  <div className="columna-izquierda-NICRO">
    <h1>SECTOR:</h1>
    <p>METALMECANICO</p>
    <h1>PAIS:</h1>
    <p>MÉXICO</p>
    <h1>EMPRESA:</h1>
      <p>Nicro Plating Group es una empresa con más de 80 años de experiencia, reconocida por su capacidad técnica, cobertura internacional y especialización en recubrimientos metálicos de alta precisión. Opera en el sector metalmecánico, pero su alcance va mucho más allá: atiende industrias como la automotriz, electrónica, médica, aeronáutica y manufactura avanzada, lo que la convierte en un proveedor estratégico multisectorial.<br></br>
      <br></br>
      Con plantas en México y Estados Unidos, certificaciones internacionales (IATF 16949, ISO 9001, ISO 14001) y procesos como niquelado, anodizado, zinc-níquel y cromado, Nicro se posiciona como una empresa robusta, versátil y con visión global.

    </p>
    <div className="boton-reto-NICRO">
      <a href="https://www.immsa.mx/" className="btn-reto-NICRO">Ver más información</a>
    </div>
  </div>

  <div className="columna-derecha-NICRO">
   <h2>RETO: REABASTECER EQUIPOS Y SUMINISTROS TI AUTOMATIZADO. </h2>
    <p>Mantener un reabastecimiento automatizado de los equipos y suministros de TI para Grupo NICRO.</p>

    <h2>SOLUCIÓN IMPLEMENTADA: SOLUCIÓN AUTOMATIZADA DE EQUIPOS Y SUMINISTROS TI PARA GRUPO NICRO.</h2>
    <p>Con el objetivo de garantizar la disponibilidad continua de equipos y suministros tecnológicos en todas las empresas del Grupo NICRO, se diseñó e implementó internamente una solución automatizada de reabastecimiento que combina inteligencia operativa, trazabilidad y eficiencia logística. <br></br>
    <br></br>
    La solución consiste en un sistema que monitorea en tiempo real los niveles de inventario de insumos TI incluyendo periféricos, consumibles, componentes de red y equipos de cómputo también se indican en el sistema los parámetros definidos por cada área usuaria.  <br></br>
    <br></br>
    Esta automatización permite una gestión proactiva del inventario, reduciendo la dependencia de intervenciones manuales y eliminando riesgos de desabasto. <br></br>
    <br></br>
    Además, el sistema mantiene un historial detallado de consumo por empresa, así como los intervalos de requerimiento por equipo, lo que permite generar alertas internas de reposición y reportes de consumo precisos y oportunos. Esta trazabilidad facilita la toma de decisiones estratégicas y mejora la planificación de compras. <br></br>
    <br></br>
    Gracias a esta implementación, Grupo NICRO ha logrado anticipar con mayor precisión las necesidades de cada una de sus empresas, optimizando tiempos de respuesta, reduciendo costos operativos y fortaleciendo la continuidad de sus operaciones tecnológicas.
</p>

    <h2>RESEÑA</h2>
    <p>Pendiente.</p>
  </div>
</div>
</div>

{/* Contenedor principal  de pie de página con contacto*/}

<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>

  <div className="footer-item">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>

  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>

  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
      <ul>
        <li><a href="/">• IAutomatiza CFDI</a></li>
        <li><a href="/Comercializacion">• Infraestructura TI</a></li>
        {/* Servicio Consultoria ERP LIBRA colum 2*/}
        <li><a href="/Consultoria">• Asesoría Empresarial</a></li>
        {/* Servicio Sistemas colum 2*/}
        <li><a href="/Sistemas">• Sistemas</a></li>
      </ul>
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
        <li><a href="/CasosExito">Ver Mas Casos de Éxito</a></li>
        <li><a href="/Nosotros">Sobre nosotros</a></li>
        <li><a href="/Legal">Aviso Legal</a></li>
      </ul>
    </div>
  </div>

  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>

</>
  );
}

export default NICRO;